import axios from 'axios';

axios.defaults.withCredentials = true;// 是否跨域

// 减少项目体积处理
// export const simplify = Simplify && new Simplify();

// const sPostApiList = [
//   '/api/user/draft',
//   '/api/user/template',
//   '/api/user/template/updateData',
//   '/api/user/video'
// ];
// const sGetApiList = [
//   '/api/user/draft',
//   '/api/common/material/templateData'
// ];
// axios.interceptors.request.use(request => {
//   if (request.method === 'post' && sPostApiList.indexOf(request.url) > -1) {
//     // console.log('Starting Request', request, request.url, request.params);
//     let obj = JSON.parse(request.data.data);
//     obj = simplify.sim(obj);
//     request.data.data = JSON.stringify(obj);
//   }

//   return request;
// });
// axios.interceptors.response.use(response => {
//   let url = response.config.url.replace(/\?.*/, '');
//   if (response.config.method === 'get' && sGetApiList.indexOf(url) > -1) {
//     // console.log('TCL: url', url);
//     // console.log('Response:', response);
//     let draftData = response.data.data.data;
//     let obj = JSON.parse(draftData);
//     if (Object.keys(obj).indexOf('s') > -1) {
//       obj = simplify.recover(obj);
//       response.data.data.data = JSON.stringify(obj);
//     }
//   }
//   return response;
// });

export default axios;



// WEBPACK FOOTER //
// ./src/plugins/http.js